<template>
  <div class="">
    <el-dialog append-to-body :show-close="false" width="550px" :visible.sync="dialogTableVisible">
      <div class="flex items-center" slot="title">
        <div class="flex-1 text-center text-[#000000] text-[15px] font-500">分享【{{ cruiseName }}】</div>
        <i class="ficon ficon-guanbi1 cursor-pointer inline-block w-[20px] h-[20px] rounded-[50%] borde border-[#8C9BB1] flex items-center justify-center"
          @click="toggleDialogTableVisible"></i>
      </div>
      <div>
        <div class="text-[#8799B3] text-xs mb-[4px]">分享链接</div>
        <div class="flex">
          <div class="flex-1 mr-[14px]">
            <div class="h-[100px] bg-[#F5F5F5] rounded p-[20px] mb-[20px]">{{ href }}</div>
            <el-button type="primary" v-clipboard="() => href" v-clipboard:success="handleCopySuccess" v-clipboard:error="handleCopyError">复制连接
            </el-button>
          </div>
          <div class="w-[110px] h-[140px] border border-[#F5F5F5] flex-col flex items-center justify-center">
            <div class="text-[#000] text-[12px] pt-[5px] pb-[4px]">上船吧微信小程序</div>
            <div class="w-[73px] h-[79px] mb-[10px]">
              <el-image class="w-full h-full" fit="contain" :src="share_qr"></el-image>
            </div>
            <div class="text-[#8799B3] text-[12px]">微信扫码二维码</div>
          </div>
        </div>
      </div>
    </el-dialog>
    <div @click="toggleDialogTableVisible">
      <slot></slot>
    </div>
  </div>
</template>

<script>
// import { useToggle } from "@vueuse/core";
import { defineComponent } from "@nuxtjs/composition-api";
import clipboard from "@/directives/clipboard";
import { getCruiseShare } from "@/services/company";
import combineURLs from "~/utils/combineURLs";
export default defineComponent({
	name: "CruiseDialogShare",
	props: {
		cruiseid: {
			type: String,
			default: ""
		},
		cruiseName: {
			type: String,
			default: ""
		}
	},
	directives: { clipboard },
	data() {
		return {
			dialogTableVisible: false,
			// href: "",
			share_qr: ""
		};
	},
	computed: {
		href() {
			if (!process.client) {
				return "";
			}
			const { href } = this.$router.resolve({
				path: `/company/cruise/${this.cruiseid}`
			});
			// console.log(location, rest)
			return combineURLs(window.location.origin,  href);
		}
	},
	// mounted() {
	// 	this.href = window.location.href;
	// },
	watch: {
		dialogTableVisible(val) {
			if (!val) return;
			if (this.qrcode) {
				return;
			}
			this._getQrcode();
		}
	},
	methods: {
		async _getQrcode() {
			const { code, data } = await getCruiseShare({ cruise_id: this.cruiseid });
			// console.log({ code, data })
			this.share_qr = data.share_qr;
		},
		toggleDialogTableVisible(flag) {
			this.dialogTableVisible = !this.dialogTableVisible;
		},
		handleCopySuccess() {
			this.$message.success("复制成功");
		},
		handleCopyError() {
			this.$message.error("复制失败");
		}
	}
});
</script>
<style lang="scss" scoped>


</style>
